
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/settings",
      function () {
        return require("private-next-pages/my/settings/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/settings"])
      });
    }
  